import React from 'react';

import { useSelector } from 'react-redux';

import MainHeader from 'components/Layouts/shared/MainHeader';
import Icon from 'components/shared/Icon';
import HourglassLow from 'components/shared/Icon/icons/HourglassLow';
import { UserMenu } from 'components/shared/Layout/shared';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { accountTypeSelector, currentAccountSelector } from 'store/user/selectors';

import { ACCOUNT_TYPE_AGENT } from '../../../../../constants';
import styles from './index.module.css';

const Header = () => {
  const { isTabletOrMobile } = useMediaBreakpoints();
  const account = useSelector(currentAccountSelector);
  const accountType = useSelector(accountTypeSelector);

  const trialEnd = new Date(account.trialEnd);
  const currentDate = new Date();
  const isTrial = trialEnd > currentDate;
  const trialInDays = Math.ceil(Math.abs(trialEnd.getTime() - currentDate.getTime()) / (1000 * 3600 * 24));

  const isVisible = accountType === ACCOUNT_TYPE_AGENT && trialInDays < 31;

  const toBeWord = trialInDays > 1 ? 'are' : 'is';
  const numeric = trialInDays > 1 ? 's' : '';
  const mail = 'mailto:sales@safariportal.app?subject=Safari Portal Subscriptions';

  return (
    <>
      {isTabletOrMobile && <MainHeader />}
      {!isTabletOrMobile && (
        <div className={styles.header}>
          {isVisible && isTrial && (
            <Text className={styles.trial}>
              <Icon component={HourglassLow} className={styles.icon} />
              <div>
                <b>
                  There {toBeWord} {trialInDays} day{numeric} left in your Free Trial.{' '}
                </b>
                <span>
                  Contact{' '}
                  <a href={mail} className={styles.trialLink}>
                    sales@safariportal.app
                  </a>{' '}
                  now to avoid a lapse in your service.
                </span>
              </div>
            </Text>
          )}
          <div className={styles.userMenu}>
            <UserMenu />
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
